module.exports = __webpack_public_path__ + "assets/img/banner1.13e2104f.jpg";